import React, { useMemo } from 'react';
import Image from '@plone/volto/components/theme/Image/Image';
import { UniversalLink } from '@plone/volto/components';
import { useHomeDestaques } from 'volto-ministerio-publico-federal/hooks/useHomeDestaques';
import {
  getDestaqueImageProps,
  toDestaqueCards,
} from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';
import { ROUTES } from 'volto-ministerio-publico-federal/config/routes.constants';
import { useRegisterExclusions } from '../NewsExclusionsContext';
import SidebarCard from './SidebarCard';

/** Máximo de destaques exibidos no card, conforme o Figma. */
const VISIBLE = 4;

/**
 * Card "Em destaque" da coluna lateral.
 *
 * Espelha o bentô `mpfDestaques` da home — mesma curadoria, mesma lista em
 * todas as páginas de notícia (requisito de design). Por isso não filtra pela
 * notícia aberta: o bloco tem de ser idêntico em toda parte.
 *
 * O rodapé "Mais conteúdos" não expande mais nada aqui: é navegação para a
 * listagem geral de notícias (`/comunicacao/noticias`).
 */
export const EmDestaque: React.FC = () => {
  const { items } = useHomeDestaques();

  const cards = useMemo(() => toDestaqueCards(items), [items]);

  // Registra para o "Mais lidas" não repetir os destaques.
  useRegisterExclusions(
    'destaques',
    cards.map((card) => card.href),
  );

  if (cards.length === 0) {
    return null;
  }

  return (
    <SidebarCard
      title="Em destaque"
      footer={
        <UniversalLink
          href={ROUTES.COMUNICACAO_NOTICIAS}
          className="mpf-news-sidebar__more"
        >
          Mais conteúdos
        </UniversalLink>
      }
    >
      <ul className="mpf-news-sidebar__list">
        {cards.slice(0, VISIBLE).map((card) => {
          const imageProps = getDestaqueImageProps(card, 'preview');
          return (
            <li key={card.key} className="mpf-news-sidebar__item">
              <UniversalLink
                href={card.href || '#'}
                openLinkInNewTab={card.external}
                className="mpf-news-sidebar__destaque"
              >
                <span className="mpf-news-sidebar__destaque-title">
                  {card.title}
                </span>
                {imageProps ? (
                  <span className="mpf-news-sidebar__destaque-image">
                    <Image {...imageProps} alt={card.alt} loading="lazy" />
                  </span>
                ) : null}
              </UniversalLink>
            </li>
          );
        })}
      </ul>
    </SidebarCard>
  );
};

export default EmDestaque;
